"use client";

import { Moon, Smartphone, Sun } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import { useSyncExternalStore } from "react";

import { cn } from "../../lib/utils";
import { useTheme } from "next-themes";

interface OrientationProps {
  orientation?: "horizontal" | "vertical";
}

function TabGroup({ orientation }: OrientationProps) {
  const { setTheme, theme } = useTheme();

  return (
    <Tabs
      orientation={orientation ?? "vertical"}
      className={cn(
        "w-full",
        orientation === "horizontal" && "justify-center flex",
      )}
      onValueChange={setTheme}
      value={theme}
    >
      <TabsList
        className={cn(
          "p-0 pl-[2px] gap-2 px-2 group",
          "bg-stone-100/50 rounded-full dark:bg-[#1014195e] hover:bg-transparent hover:dark:bg-transparent",
          !orientation && "rotate-90 relative top-8 right-12",
        )}
      >
        <TabsTrigger className="p-1 rounded-full" value="light">
          <Sun size={13} />
        </TabsTrigger>
        <TabsTrigger className="p-1 rounded-full" value="dark">
          <Moon size={13} />
        </TabsTrigger>
        {orientation === "horizontal" &&
          // <TabsTrigger className="p-1 rounded-full hidden group-hover:block" value="system">
          // 	<Smartphone size={13} />
          // </TabsTrigger>
          null}
      </TabsList>
    </Tabs>
  );
}

function ThemeTabs({ orientation }: OrientationProps) {
  const isClient = useSyncExternalStore(
    () => () => {},
    () => true,
    () => false,
  );

  if (!isClient) return null; // Only render on client

  return <TabGroup orientation={orientation} />;
}

export default ThemeTabs;
